/**
 * 句型跟讀追蹤鉤子 — 每句最近一次評分落地 localStorage(P3a → P3c 發音弱點追蹤
 * 鋪路;此檔**只存資料,不做 UI**)。
 *
 * 鐵則:純學習側、錄音不上雲(這裡只存分數與漏唸字,不存任何音訊);不碰
 * commanderXp / factionXP 等任何進度數值。
 */

/** localStorage key(單一真相)。 */
export const SHADOWING_STORE_KEY = 'ef.oral.shadowing';

/** 一句的最近評分紀錄。 */
export interface ShadowingRecord {
  /** 0..100 涵蓋率百分數。 */
  percent: number;
  /** 漏唸 / 沒對上的目標字(P3c 弱點分析素材)。 */
  missed: string[];
  /** ISO 時間戳。 */
  at: string;
}

/** 全部紀錄:sentenceId → 最近一次評分。 */
export type ShadowingScores = Record<string, ShadowingRecord>;

/** 讀出全部跟讀評分(壞 JSON / 無資料回空物件,不丟例外)。 */
export function loadShadowingScores(storage: Pick<Storage, 'getItem'> = localStorage): ShadowingScores {
  try {
    const raw = storage.getItem(SHADOWING_STORE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed as ShadowingScores;
  } catch {
    return {};
  }
}

/**
 * 記一句最近評分(覆蓋同句舊紀錄)。寫入失敗(配額 / 私密模式)靜默吞掉 ——
 * 追蹤是輔助,不能弄壞練習流程。
 */
export function recordShadowingScore(
  sentenceId: string,
  result: { percent: number; missed: string[] },
  storage: Pick<Storage, 'getItem' | 'setItem'> = localStorage,
): void {
  try {
    const all = loadShadowingScores(storage);
    all[sentenceId] = {
      percent: Math.max(0, Math.min(100, Math.round(result.percent))),
      missed: [...result.missed],
      at: new Date().toISOString(),
    };
    storage.setItem(SHADOWING_STORE_KEY, JSON.stringify(all));
  } catch {
    /* 追蹤失敗不影響練習 */
  }
}
